import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumb } from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { PageTrafficTable } from "../../components/Players.js";

import {
  faCashRegister,
  faChartLine,
  faCloudUploadAlt,
  faPlus,
  faRocket,
  faTasks,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Button,
  Dropdown,
  ButtonGroup,
} from "@themesberg/react-bootstrap";

import {
  CounterWidget,
  CircleChartWidget,
  BarChartWidget,
  TeamMembersWidget,
  ProgressTrackWidget,
  RankingWidget,
  SalesValueWidget,
  SalesValueWidgetPhone,
  AcquisitionWidget,
} from "../../components/Widgets";
import { PageVisitsTable } from "../../components/Tables";
import { trafficShares, totalOrders } from "../../data/charts";
import logo from "../../components/Images/logo.jpg";
import mallvarna from "../../components/Images/mallvarna.jpg";

export default () => {
  return (
    <>

      <header className='container'>
        <div className='left site__logo'>
          <a href='/#/home'>
            <img src={logo} className='logo' alt='rank' />
          </a>
        </div>
        <div className='middle'>
          <h1 className='page__title'>Table Tennis Center Ранкинг</h1>
        </div>
        <div class='right site__logo_main'>
          <a href='/' target='_blank' title='ITTF'>
            <img src={mallvarna} class='logo' alt='rank2' />
          </a>
        </div>
      </header>
      <div id='mainContainer'>
        <PageTrafficTable />
      </div>
    </>
  );
};
